export class NotificationMessageMapping {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketPath",
            "baseName": "bucketPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "objectKeyPath",
            "baseName": "objectKeyPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "eventTypePath",
            "baseName": "eventTypePath",
            "type": "string",
            "format": ""
        },
        {
            "name": "eventTypePrefixFilter",
            "baseName": "eventTypePrefixFilter",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizePath",
            "baseName": "sizePath",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationMessageMapping.attributeTypeMap;
    }
    constructor() {
    }
}
